import {BrowserTracing, init, reactRouterV6Instrumentation, withSentryReactRouterV6Routing} from '@sentry/react'
import {useEffect} from 'react'
import {createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType} from 'react-router-dom'

if (process.env.NODE_ENV !== 'development') {
  init({
    dsn: 'https://a5cf61430a12550a71e24b2ac479049f@o4505997054115840.ingest.sentry.io/4505997057785856',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: reactRouterV6Instrumentation(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    normalizeDepth: 10,
  })
}

export const SentryRoutes = process.env.NODE_ENV === 'development' ? Routes : withSentryReactRouterV6Routing(Routes)